// Core
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Space } from 'antd';
import Button from 'components/commonComponents/Button';
import PropTypes from 'prop-types';
import ReactAudioPlayer from 'react-audio-player';

// Styles
import './styles.scss';

const AudioPlayerModal = (props) => {
  const { onClose, open, files,title } = props;
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    // setIsPlaying(files[0]?.audio)
  }, []);

  return (
    <Modal
      title={`${title}`}
      open={open}
      onCancel={handleCancel}
      className="__common_model_class"
      width={600}
      maskClosable={false}
      keyboard={false}
      footer={[
        <Button
          key="cancel"
          label={t('cancel')}
          handleOnClick={handleClose}
        />
      ]}
    >
      <div className="mt-2">
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          {files?.map((file, index) => (
            <div key={index} style={{ width: '100%' }}>
              <div className='__audio_model_class_head'>
                {file.audioTitle}
              </div>
              <ReactAudioPlayer
                src={file.audioLink}
                controls
                style={{ width: '100%' }}
              />
            </div>
          ))}
        </Space>
      </div>
    </Modal>
  );
};

AudioPlayerModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  files: PropTypes.any,
};

export default AudioPlayerModal;